module.exports = __webpack_public_path__ + "img/logo-MeetingHubSmall.29cdac29.png";